// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vuRjI","colBig":"styles_colBig__3lLU3","colSmall":"styles_colSmall__ySA4D","shopifyNameWrapper":"styles_shopifyNameWrapper__3HL5V"};